import React from 'react';
import Header from './Header/Header.js';
import Plates from './Plates/Plates.js';

let PlateSection = (props) => {    
    return (
        <div className="Plate_Section">
            <Header id={props.id} author={props.author} title={props.title} image={props.imageUrl} 
                description={props.description} modalToggle={props.modalToggle}
                deskTop={props.deskTop} plates={props.plates}               
            />                
            <Plates id={props.id} deskTop={props.deskTop} modalToggle={props.modalToggle} plates={props.plates}/>
        </div>
    );   
}

export default PlateSection;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/Components/PlateSection/PlateSection.js